import { IShowcaseCourse } from 'interface/showcase';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button, Typography } from '@material-ui/core';
import LockIcon from '@eduzz/houston-icons/LockedSolid';
import ClockLock from '@eduzz/houston-icons/TimerOutline';
import InfoIcon from '@material-ui/icons/Info';

import { enStatus } from 'interface/course';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { dateFormater, slugify } from 'utils';
import { useRef } from 'react';
import { useHistory } from 'react-router';

interface IProps {
  course: IShowcaseCourse;
  isNewCourse: boolean;
}

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.common.white,
    '@media(max-width: 1500px)': {
      height: 20,
      fontSize: 20,
    },
    '@media(max-width: 1366px)': {
      height: 14,
      fontSize: 14,
    },
    '@media(max-width: 1024px)': {
      height: 10,
      fontSize: 10,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (min-width: 1025 and max-width: 1366px)': {
      width: 24,
      height: 24,
      '& .houston-icon': {
        width: '24px !important',
        height: '24px !important',

        '& > svg': {
          width: '24px !important',
          height: '24px !important',
        },
      },
    },

    '@media (min-width: 1367px)': {
      width: 32,
      height: 32,
      '& .houston-icon': {
        width: '32px !important',
        height: '32px !important',

        '& > svg': {
          width: '32px !important',
          height: '32px !important',
        },
      },
    },
    '& .houston-icon > svg': {
      color: theme.palette.grey[200],
    },
  },
  text: {
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.grey[600],
  },
  blockedTitle: {
    color: theme.palette.common.white,
    whiteSpace: 'nowrap',
    '@media(max-width: 1308px)': {
      marginTop: theme.spacing(2),
    },
    '@media(max-width: 1440px)': {
      fontSize: 12,
    },
    '@media(max-width: 1331px)': {
      fontSize: 12,
    },
  },
  blockedText: {
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.grey[600],
    '@media(max-width: 1440px)': {
      fontSize: 12,
    },
  },
  whiteButton: {
    background: theme.palette.grey[200],
    '&:hover': {
      background: theme.palette.grey[300],
    },
    '& > span': {
      paddingRight: theme.spacing(1),
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.grey[600],
      whiteSpace: 'nowrap',
      '& svg': {
        color: theme.palette.grey[600],
        width: '16px !important',
      },
    },
    '@media(min-width: 770px) and (max-width: 1440px)': {
      '& > svg': {
        width: '14px !important',
      },
      '& > span': {
        fontSize: 10,
      },
    },
  },
}));

const CourseStatus = (props: IProps) => {
  const classes = useStyles();
  const history = useHistory();
  const { current: iconStatusMapper } = useRef({
    [enStatus.EXPIRED]: <ClockLock />,
    [enStatus.NOT_RELEASED]: <LockIcon />,
    new: <SvgIcon name='bell' />,
  });
  const { current: titleStatusMapper } = useRef({
    [enStatus.EXPIRED]: `Expirado - ${dateFormater(String(props.course.expire_at))}`,
    [enStatus.NOT_RELEASED]: `Lançamento - ${dateFormater(String(props.course.release_at))}`,
  });

  const openCourse = () => {
    history.push(`/curso/${props.course.hash}/${props.course.slug || slugify(props.course.title)}`);
  };

  const status = props.isNewCourse ? 'new' : props.course.status;

  if (status === enStatus.BLOCKED) {
    return (
      <div className={classes.container}>
        <Button
          startIcon={<InfoIcon width={14} height={14} />}
          onClick={openCourse}
          variant='contained'
          className={classes.whiteButton}
        >
          <Typography className={classes.blockedText} component='span'>
            Saiba mais
          </Typography>
        </Button>
        <Typography variant='body1' className={classes.blockedTitle} component='span'>
          <b>Curso Bloqueado</b>
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <Typography variant='h3' className={classes.title}>
        <b>{titleStatusMapper[props.course.status]}</b>
      </Typography>
      <span className={classes.icon}>{iconStatusMapper[status]}</span>
    </div>
  );
};

export default CourseStatus;
